import { render, staticRenderFns } from "./TravelDetached.vue?vue&type=template&id=c772cf80&"
import script from "./TravelDetached.vue?vue&type=script&lang=ts&"
export * from "./TravelDetached.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports